import { useWindowSize } from "common-custom-hooks";

export const useIsMobile = () => {
  const { width } = useWindowSize();
  return width && width <= 576;
};

export const useIsTab = () => {
  const { width } = useWindowSize();
  return width && width > 577 && width <= 768;
};

export const useIsMidTabWindow = () => {
  const { width } = useWindowSize();
  return width && width > 769 && width <= 992;
};

export const useIsmidSizedMonitor = () => {
  const { width } = useWindowSize();
  return width && width > 993 && width <= 1199;
};
